var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('targeting-info-checkbox',{attrs:{"fieldName":"allowRetargeting","label":_vm.$t('targeting.info.allow.retargeting.title'),"popover":_vm.$t('allow.retargeting.checkbox.popover')}})}
var staticRenderFns = []

export { render, staticRenderFns }